import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { RequestsService } from 'src/app/services/api/requests.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-request-categories-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './request-categories-index-page.component.html',
  styleUrl: './request-categories-index-page.component.scss'
})
export class RequestCategoriesIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected requestsService: RequestsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Request Categories',
      cardTitle: 'Manage Request Categories',
      addNewItemButton: {
        type: 'success',
        title: 'Add Category',
        onClick: () => {
          this.routeService.requestsSettingsRequestCategoriesCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View category details',
                onClick: (item: any) => {
                  this.routeService.requestsSettingsRequestCategoriesDetail(item.requestCategoryId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit category',
                onClick: (item: any) => {
                  this.routeService.requestsSettingsRequestCategoriesUpdate(item.requestCategoryId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete category',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((category: any) => category.requestCategoryId !== item.requestCategoryId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.requestsService.listSettingsRequestCategories(options),
      responseListModelName: 'requestCategories',
    }
  }
}
